import type { Currency } from '@ps/web-core-enums';
import React from 'react';
import type { FormatNumberOptions } from 'react-intl';
import { FormattedNumber } from 'react-intl';

import type { Props as CurrencyAmountProps } from '@swf/components/CurrencyAmount/CurrencyAmount';
import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import { calculateCurrencyAmount } from '../../utils';

export interface Props {
  amount?: number;
  scalePM?: number;
  isPlayMoney?: boolean;
  currency?: Currency;
  notationPM?: FormatNumberOptions['notation'];
  currencyDisplay?: CurrencyAmountProps['currencyDisplay'];
}

const FormattedCurrencyAmount: React.FC<Props> = ({
  amount,
  scalePM = 1,
  isPlayMoney = false,
  currency,
  notationPM,
  currencyDisplay
}) => {
  if (isPlayMoney) {
    const calculatedAmount = calculateCurrencyAmount({ amount, scalePM });
    const maximumFractionDigits = notationPM && calculatedAmount > 1000 ? 2 : 0;

    return (
      <FormattedNumber
        value={calculatedAmount}
        maximumFractionDigits={maximumFractionDigits}
        notation={notationPM}
      />
    );
  }

  return (
    <CurrencyAmount
      value={Number(amount)}
      currency={currency as Currency}
      minimumFractionDigits={Number(amount) % 100 !== 0 ? 2 : 0}
      currencyDisplay={currencyDisplay}
    />
  );
};

export default FormattedCurrencyAmount;
